var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFormCheckboxSelected = function SvgIconsFormCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 4c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h12zm-.725 4.247c-.282-.295-.73-.327-1.048-.09l-.082.072-5.909 5.826-2.38-2.349-.083-.071c-.317-.238-.766-.206-1.048.089-.279.293-.298.745-.06 1.06l.078.09L9.68 15.77l.08.07c.28.21.662.212.943.006l.09-.076 6.463-6.375.073-.082c.243-.315.226-.772-.055-1.067z"
  })));
};
export default SvgIconsFormCheckboxSelected;